export const AnalyticsEvents = {
  IDENTIFY: "identify",
  BUTTON_CLICK: "ButtonClick",
  FORM_SUBMISSION: "FormSubmission",
}
